import { useContext } from 'react';
import GeneralContext from '../contexts/GeneralContext';

const useGeneral = () => useContext(GeneralContext);

export default useGeneral;
